import { toBackendDate } from './dashboardDates'

export const AFFILIATE_STATUS_COPY = {
  active: { text: 'Activo', variant: 'success' },
  payment_failed: { text: 'Pago fallido', variant: 'danger' },
  cancel_scheduled: { text: 'Cancelación programada', variant: 'warning' },
  canceled: { text: 'Cancelado', variant: 'secondary' },
  pending_payment: { text: 'Pago pendiente', variant: 'light' },
}

/** El filtro del backend acepta estos cuatro; pending_payment solo aparece sin filtro. */
export const AFFILIATE_STATUS_OPTIONS = [
  { value: null, text: 'Todos' },
  { value: 'active', text: 'Activos' },
  { value: 'payment_failed', text: 'Pago fallido' },
  { value: 'cancel_scheduled', text: 'Cancelación programada' },
  { value: 'canceled', text: 'Cancelados' },
]

export const PLAN_KIND_COPY = {
  individual: 'Individual',
  family: 'Familiar',
  company: 'Empresa',
}

export const BILLING_INTERVAL_COPY = {
  month: 'Mensual',
  quarter: 'Trimestral',
  year: 'Anual',
}

export const PATIENT_FLOW_COPY = {
  generated: { text: 'Generó', variant: 'success' },
  excluded_type: { text: 'No genera: tipo excluido', variant: 'secondary' },
  not_attended: { text: 'No asistió', variant: 'warning' },
  pending_calculation: { text: 'Asistida; se calcula el día 1 del mes siguiente', variant: 'info' },
  not_referred: { text: 'No salió de una solicitud tuya', variant: 'light' },
}

export const REQUEST_STATUS_COPY = {
  pending: { text: 'Pendiente', variant: 'warning' },
  accepted: { text: 'Aceptada', variant: 'success' },
  rejected: { text: 'Rechazada', variant: 'danger' },
}

export const COMMISSION_STATUS_COPY = {
  on_hold: { text: 'Retenida por garantía', variant: 'warning' },
  pending: { text: 'Pendiente', variant: 'secondary' },
  payable: { text: 'Por pagar', variant: 'info' },
  paid: { text: 'Pagada', variant: 'success' },
}

export const MEMBER_TYPE_COPY = {
  holder: 'Titular',
  member: 'Integrante',
  employee: 'Empleado',
}

/**
 * Texto y color de un estado; si el backend manda uno nuevo, se muestra tal cual.
 * @param {Object} copy
 * @param {string} value
 * @returns {{text: string, variant: string}}
 */
export function statusBadge(copy, value) {
  return copy[value] || { text: value || '—', variant: 'light' }
}

/** Montos llegan como string "51.00"; los descuentos por garantía vienen negativos. */
export function money(value) {
  const amount = Number(value)
  const safe = Number.isFinite(amount) ? amount : 0
  return `${safe < 0 ? '-' : ''}$${Math.abs(safe).toFixed(2)}`
}

/**
 * Página de Laravel ({ data, total, from, to, current_page }) lista para PaginationTable.
 * @param {*} payload - respuesta { status, data } o el paginador directo
 * @returns {{items: Array, total: number, from: number, to: number, page: number}}
 */
export function unwrapPage(payload) {
  const body = payload && payload.status && payload.data !== undefined ? payload.data : payload
  const items = body && Array.isArray(body.data) ? body.data : []
  return {
    items,
    total: Number(body && body.total) || 0,
    from: Number(body && body.from) || 0,
    to: Number(body && body.to) || 0,
    page: Number(body && body.current_page) || 1,
  }
}

/**
 * Parámetros de fecha en m-d-Y. Sin fechas el backend usa el mes en curso.
 * @param {{start_date?: string, end_date?: string}} range - fechas Y-m-d del selector
 * @returns {Object}
 */
export function rangeParams(range) {
  const params = {}
  if (range && range.start_date) params.start_date = toBackendDate(range.start_date)
  if (range && range.end_date) params.end_date = toBackendDate(range.end_date)
  return params
}

/**
 * Porcentaje de la barra Élite. El backend manda null si no hay regla vigente.
 * @param {Object|null} progress - { active, threshold }
 * @returns {number}
 */
export function elitePercent(progress) {
  if (!progress || !Number(progress.threshold)) return 0
  return Math.min(100, Math.round((Number(progress.active) / Number(progress.threshold)) * 100))
}
